// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2fOBT","sendOtp":"AuthorizeToLogin_sendOtp__HZkuA"};